import React, { useState, useMemo, useEffect, useRef } from "react";
import { useGlobalContext } from "../../GlobalContext";
import RealMap from "../Maps/RealMap";
import GoogleMapView from "../Maps/GoogleMapView";
import { Toaster, toast } from "sonner";
import axios from "axios";
import { ChevronDown } from "lucide-react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import SendNotificationModal from "../Driver//SendNotificationModal";
import { motion, AnimatePresence } from "framer-motion";
import { XCircle, CheckCircle, X } from "lucide-react";

// Tabs for tasks and agents
const CustomSelectDriver = ({
  agents,
  selectedAgentId,
  setSelectedAgentId,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (agent) => {
    if (agent.dutyStatus === "offline") return;
    setSelectedAgentId(agent.driverId);
    setIsOpen(false);
  };

  const selectedAgent = agents.find((a) => a.driverId === selectedAgentId);

  return (
    <div className="relative w-full mb-4">
      <button
        type="button"
        className="w-full border px-3 py-2 rounded flex justify-between items-center bg-white"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span>
          {selectedAgent
            ? `${selectedAgent.fullName} (${selectedAgent.dutyStatus})`
            : "Select Driver"}
        </span>
        <ChevronDown className="w-4 h-4 text-gray-600" /> {/* Lucide Icon */}
      </button>

      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full border bg-white rounded shadow-lg max-h-60 overflow-y-auto">
          {agents.map((agent) => (
            <li
              key={agent.driverId}
              className={`flex justify-between items-center px-4 py-2 hover:bg-gray-100 ${agent.dutyStatus === "offline"
                  ? "opacity-50 cursor-not-allowed"
                  : "cursor-pointer"
                }`}
              onClick={() => handleSelect(agent)}
            >
              <span>{agent.fullName}</span>
              {agent.dutyStatus === "offline" && (
                <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">
                  Offline
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
const taskTabs = ["unassigned", "assigned", "successful"];

const ModalContentShimmer = () => (
  <div className="animate-pulse">
    <div className="flex flex-col lg:flex-row gap-4">
      {/* Map placeholder */}
      <div className="w-full lg:w-1/2 h-64 bg-gray-200 rounded animate-pulse" />

      {/* Table placeholder */}
      <div className="w-full lg:w-1/2">
        <div className="w-full border rounded">
          {Array.from({ length: 7 }).map((_, index) => (
            <div key={index} className="flex border-b">
              <div className="w-1/3 px-2 py-3 bg-gray-100">
                <div className="h-3 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className="w-2/3 px-2 py-3">
                <div className="h-3 bg-gray-200 rounded animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Address section */}
    <div className="mt-4 space-y-2">
      <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse" />
      <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse" />
    </div>

    {/* Items section */}
    <div className="mt-6">
      <div className="h-5 bg-gray-200 rounded w-1/4 mb-2 animate-pulse" />
      <div className="w-full border rounded">
        <div className="bg-gray-100 border-b">
          <div className="flex">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="flex-1 px-2 py-2">
                <div className="h-3 bg-gray-200 rounded animate-pulse" />
              </div>
            ))}
          </div>
        </div>
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="flex border-b">
            {Array.from({ length: 5 }).map((_, cellIndex) => (
              <div key={cellIndex} className="flex-1 px-2 py-2">
                <div className="h-3 bg-gray-200 rounded animate-pulse" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default function MapDashboardOld({
  tasks,
  setTasks,
  agents,
  loading,
  isLoading,
  fromDate,
  toDate,
  // shops,
  isAutoAssignChecked,
  autoAssignLoading,
  teams,
  selectedTeam,
  setSelectedTeam,
  setFromDate,
  setToDate,
  FetchTaskCall,
  FetchDriverCall,
  SyncWithAnlook,
  AssignTaskToDriver,
  // handleAutoAssignToggle,
  handleToggle,
  isChecked,
  setIsChecked,
  baseurl,
  token,
  accessToken,
  setIsUnauthorised,
  showOld,
  setShowOld,
}) {
  const {
    team,
    searchQueryGlobal,
    ApiCall,
    // setIsUnauthorised,
    socketData,
    AdminId
  } = useGlobalContext();
  const [selectedTaskTab, setSelectedTaskTab] = useState("unassigned");
  const [selectedAgentTab, setSelectedAgentTab] = useState("active");
  const [searchQuery, setSearchQuery] = useState("");
  const [taskDate, setTaskDate] = useState("2025-05-17");
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [taskToAssign, setTaskToAssign] = useState(null);
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [notificationAgent, setNotificationAgent] = useState(null);
  const [localNewStatus, setLocalNewStatus] = useState("");
  const [assignmentLogs, setAssignmentLogs] = useState([]);
  const [statusChangeLogs, setStatusChangeLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const [isStatusChanging, setIsStatusChanging] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  useEffect(() => {
    console.log(selectedTask);
  }, [selectedTask]);

  // Set default dates on mount
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);

    const format = (date) => date.toISOString().split("T")[0];

    setToDate(format(today));
    setFromDate(format(today));
  }, []);

  const TaskCardSkeleton = () => (
    <div className="bg-white rounded-lg shadow border-l-4 p-3 border-orange-300 animate-pulse">
      <div className="flex justify-between items-center mb-2">
        <div className="h-4 bg-gray-200 rounded w-2/3" />
        <div className="h-6 w-20 bg-gray-200 rounded" />
      </div>
      <hr className="my-2 border-gray-200" />
      <div className="space-y-2 bg-gray-100 p-3 rounded text-xs">
        <div className="h-3 bg-gray-200 rounded w-5/6" />
        <div className="h-3 bg-gray-200 rounded w-4/6" />
        <div className="h-3 bg-gray-200 rounded w-3/6" />
      </div>
      <div className="mt-2 h-4 w-16 bg-gray-200 rounded" />
    </div>
  );

  const iconRed = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  const iconYellow = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-yellow.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  const iconDriverActive = new L.Icon({
    iconUrl: "http://bumppy.in/packky/api/v1/uploads/images/driver_icon.png",
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -25],
  });
  const agentTabs = ["active", "offline", "total"];

  const getAgentTabCount = (tab) => {
    if (tab === "total") return agents.length;
    return agents.filter((agent) => agent.dutyStatus?.toLowerCase() === tab)
      .length;
  };
  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "assigned":
        return "bg-blue-100 text-blue-600";
      case "started":
        return "bg-yellow-100 text-yellow-700";
      case "inprogress":
        return "bg-indigo-100 text-indigo-700";
      case "food is ready":
        return "bg-purple-100 text-purple-700";
      case "picked up":
        return "bg-orange-100 text-orange-700";
      case "acknowledged":
        return "bg-teal-100 text-teal-700";
      case "failed":
        return "bg-red-100 text-red-700";
      case "declined":
        return "bg-pink-100 text-pink-700";
      case "cancelled":
        return "bg-red-100 text-red-700";
      case "successful":
        return "bg-green-100 text-green-700";
      default:
        return "bg-gray-100 text-gray-600";
    }
  };

  const statusOptions = [
    "unassigned",
    "assigned",
    "started",
    "inprogress",
    "successful",
    "food is ready",
    "acknowledged",
    "failed",
    "declined",
    "cancelled",
    "picked up",
    "arrived",
  ];

  const filteredTasks = useMemo(() => {
    if (!tasks) return [];

    if (selectedTaskTab === "unassigned") {
      return tasks.filter((task) => task.status === "unassigned");
    }

    if (selectedTaskTab === "successful") {
      return tasks.filter((task) => task.status === "successful");
    }

    return tasks.filter(
      (task) => !["unassigned", "successful"].includes(task.status)
    );
  }, [tasks, selectedTaskTab]);

  // Filter agents based on selected tab and search
  const filteredAgents = useMemo(() => {
    let list =
      selectedAgentTab === "total"
        ? agents
        : agents.filter(
          (a) => a.dutyStatus?.toLowerCase() === selectedAgentTab
        ); // "active" or "offline"
    return list.filter((a) =>
      a.fullName?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [agents, selectedAgentTab, searchQuery]);

  const assignTask = (taskId, agentId) => {
    setTasks((prev) =>
      prev.map((task) =>
        task.id === taskId ? { ...task, status: "assigned", agentId } : task
      )
    );
  };

  const handleAssignTask = async () => {
    if (!selectedAgentId || !taskToAssign) {
      console.error("Missing agent ID or task to assign");
      return;
    }

    try {
      const success = await AssignTaskToDriver(
        taskToAssign.pk_task_id,
        selectedAgentId
      );
      if (success) {
        setShowAssignModal(false);
        setTaskToAssign(null);
        setSelectedAgentId("");
        await FetchTaskCall();
      }
    } catch (error) {
      console.error("Error assigning task:", error);
    }
  };

  const handleChangeStatus = async () => {
    if (!localNewStatus || !selectedTask) {
      toast.error("Please select a valid status.");
      return;
    }

    setIsModalLoading(true);
    const payload = {
      taskId: selectedTask.pk_task_id.toString(),
      status: localNewStatus,
      driverId: selectedTask.driver_id?.toString() || "0", adminId: AdminId
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/changeTaskStatus`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage || "Status updated.");
        await FetchTaskCall();
        setShowDetailsModal(false);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update status."
        );
      }
    } catch (err) {
      toast.error("Error changing task status.");
    } finally {
      setIsModalLoading(false);
    }
  };

  const fetchTaskLogs = async (taskId) => {
    const payload = {
      fromDate,
      toDate,
      taskId: taskId.toString(), adminId: AdminId
    };

    try {
      // Assignment Logs
      const assignmentRes = await axios.post(
        `${baseurl}/api/Task/v1.0/getTaskAssignmentLogs`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (assignmentRes.data.responseCode === "00") {
        setAssignmentLogs(assignmentRes.data.data || []);
      } else if (assignmentRes.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        setAssignmentLogs([]);
      }

      // Status Change Logs
      const statusChangeRes = await axios.post(
        `${baseurl}/api/Task/v1.0/getTaskStatusChangeLogs`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (statusChangeRes.data.responseCode === "00") {
        setStatusChangeLogs(statusChangeRes.data.data || []);
      } else {
        setStatusChangeLogs([]);
      }
    } catch (err) {
      console.error("Error fetching task logs:", err);
      toast.error("Error fetching logs");
      setAssignmentLogs([]);
      setStatusChangeLogs([]);
    }
  };

  const handleLogsToggle = () => {
    if (!showLogs && selectedTask) {
      fetchTaskLogs(selectedTask.pk_task_id);
    }
    setShowLogs(!showLogs);
  };

  useEffect(() => {
    if (selectedTask?.status) {
      setLocalNewStatus(selectedTask.status.toLowerCase());
    }
  }, [selectedTask]);

  useEffect(() => {
    if (contentRef.current) {
      if (showLogs) {
        setContentHeight(contentRef.current.scrollHeight);
      } else {
        setContentHeight(0);
      }
    }
  }, [showLogs, statusChangeLogs, assignmentLogs]);

  return (
    <div className="flex w-full h-full overflow-hidden">
      {/* Left Panel: Task Overview */}
      <div className="w-[380px] min-w-[380px] bg-gray-50 border-r border-gray-200 rounded-lg shadow-sm h-full flex flex-col">
        {/* Header */}
        <div className="text-black p-3 flex justify-between font-semibold text-2xl border-b bg-white z-10">
          Tasks
          <div
            role="tablist"
            aria-label="Switch Auto/Manual"
            className={`relative inline-grid grid-cols-2 w-[88px] rounded-full bg-gray-100 border border-gray-200 p-1 ${loading ? "opacity-60 pointer-events-none" : ""
              }`}
          >
            {/* Sliding pill (white like Task/Map) */}
            <span
              aria-hidden="true"
              className="absolute top-1 bottom-1 left-1 rounded-full bg-white shadow transition-transform duration-300 ease-in-out pointer-events-none"
              style={{
                width: "calc(50% - 0.25rem)",
                transform: isChecked ? "translateX(100%)" : "translateX(0%)",
              }}
            />

            {/* Manual (left) */}
            <button
              type="button"
              role="tab"
              aria-selected={!isChecked}
              className="relative z-10 flex items-center justify-center px-1 py-1 rounded-full"
              onClick={() => handleToggle(false)}
            >
              <XCircle
                className={`h-4 w-4 ${!isChecked ? "text-red-500" : "text-gray-500"
                  }`}
              />
            </button>

            {/* Auto (right) */}
            <button
              type="button"
              role="tab"
              aria-selected={isChecked}
              className="relative z-10 flex items-center justify-center px-1 py-1 rounded-full"
              onClick={() => handleToggle(true)}
            >
              <CheckCircle
                className={`h-4 w-4 ${isChecked ? "text-green-600" : "text-gray-500"
                  }`}
              />
            </button>
          </div>
        </div>
        <Toaster position="top-right" />

        {/* Sticky Filters */}
        <div className="sticky top-0 z-10 bg-gray-50">
          {/* Task date selector */}
          <div className="flex justify-between gap-2 py-2 px-3 border-b bg-white">
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="bg-white border px-3 py-1 rounded text-sm shadow-sm"
            />
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="bg-white border px-3 py-1 rounded text-sm shadow-sm"
            />
          </div>

          {/* Task tabs */}
          <div className="flex justify-around border-b bg-white px-3 py-1 shadow-sm">
            {taskTabs.map((tab) => (
              <div
                key={tab}
                className={`cursor-pointer px-2 py-1 text-center text-xs font-medium rounded-t-md transition-all duration-200 ${selectedTaskTab === tab
                    ? "text-orange-600 border-b-2 border-orange-600"
                    : "text-gray-600"
                  }`}
                onClick={() => setSelectedTaskTab(tab)}
              >
                <div className="text-lg font-bold">
                  {tasks?.filter((t) => {
                    if (tab === "assigned") {
                      return [
                        "assigned",
                        "started",
                        "inprogress",
                        "food is ready",
                        "acknowledged",
                        "failed",
                        "declined",
                        "cancelled",
                        "picked up",
                        "arrived",
                      ].includes(t.status);
                    }
                    return t.status === tab;
                  }).length || "00"}
                </div>
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </div>
            ))}
          </div>
        </div>

        {/* Scrollable task list */}
        <div
          className="overflow-y-auto p-3 space-y-3"
          style={{ maxHeight: "calc(100vh - 220px)" }}
        >
          {isLoading
            ? Array.from({ length: 6 }).map((_, index) => (
              <TaskCardSkeleton key={index} />
            ))
            : filteredTasks
              ?.filter((task) => {
                if (selectedTaskTab === "unassigned")
                  return task.status === "unassigned";
                if (selectedTaskTab === "successful")
                  return task.status === "successful";
                return [
                  "assigned",
                  "started",
                  "inprogress",
                  "food is ready",
                  "acknowledged",
                  "failed",
                  "declined",
                  "cancelled",
                  "picked up",
                  "arrived",
                ].includes(task.status);
              })
              .map((task) => {
                const assignedAgent = agents.find(
                  (a) => a.id === task.agentId
                );
                const isAssigned = task.status === "assigned";

                return (
                  <div
                    key={task.id}
                    className="relative bg-white rounded-lg shadow border-l-4 p-3"
                    style={{ borderColor: "#FC981B" }}
                  >
                    {/* Top Row */}
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-semibold">
                        Order : {task.order_id} / {task.pk_task_id} /{" "}
                        {task.merchant_order_id}
                      </span>

                      {task.status === "unassigned" ? (
                        <button
                          className="text-xs bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                          onClick={() => {
                            setTaskToAssign(task);
                            setSelectedAgentId("");
                            setShowAssignModal(true);
                          }}
                        >
                          Assign Driver
                        </button>
                      ) : (
                        <span
                          className={`inline-flex items-center justify-center text-xs font-medium rounded-full ${getStatusBadgeColor(
                            task.status
                          )}`}
                          style={{
                            minWidth: "130px",
                            height: "28px",
                            padding: "0 0.5rem",
                          }}
                        >
                          {task.status.charAt(0).toUpperCase() +
                            task.status.slice(1)}
                        </span>
                      )}
                    </div>

                    <hr className="my-2 border-gray-300" />

                    {/* Details */}
                    <div className="bg-gray-100 rounded-md p-3 space-y-2 text-xs text-gray-700">
                      {isAssigned && (
                        <div>
                          <b>Task:</b> {task.task_description}
                        </div>
                      )}
                      <div>
                        <b>Pickup:</b> {task.pickup_address}
                      </div>
                      <div>
                        <b>Drop:</b> {task.delivery_address}
                      </div>
                      {task.driver_name && (
                        <div>
                          <b>Driver:</b> {task.driver_name} /{" "}
                          {task.driver_mobile}
                        </div>
                      )}
                    </div>
                    <div className="flex ">
                      {" "}
                      <button
                        onClick={() => SyncWithAnlook(task.pk_task_id)}
                        className="text-orange-500 mr-2"
                        title="Sync With Anlook"
                      >
                        ⟳
                      </button>
                      <div
                        className="text-sm cursor-pointer text-blue-600 underline"
                        onClick={() => {
                          setSelectedTask(task);
                          setShowDetailsModal(true);
                        }}
                      >
                        Details
                      </div>
                    </div>
                  </div>
                );
              })}
        </div>
      </div>

      {/* Middle Panel: Map Area */}
      <div className="flex-1 bg-gradient-to-br from-yellow-100 to-red-100 text-gray-700 flex items-center justify-center rounded-lg shadow-inner relative z-0">
        <div className="w-full h-full overflow-hidden shadow">
          <RealMap Task={tasks} drivers={agents} />
        </div>
      </div>

      {/* Right Panel: Agent Overview */}
      <div className="w-[320px] min-w-[360px] bg-gray-50 border-l border-gray-200 rounded-lg shadow-sm flex flex-col h-full">
        <div className=" justify-between items-center px-3 py-2 border-b text-2xl font-semibold">
          <p className="mb-3">Agents</p>
          <div className="flex items-between space-x-2 text-sm w-full">
            <input
              type="text"
              placeholder="Search"
              className="border px-2 py-1 rounded w-full"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              onClick={() => FetchDriverCall()}
              className="text-orange-500"
            >
              ⟳
            </button>
          </div>
        </div>

        {/* Agent tabs */}
        <div className="flex justify-around mt-2 text-center border-b pb-1 mx-2 bg-white shadow-sm">
          {agentTabs.map((tab) => (
            <div
              key={tab}
              className={`px-2 py-1 cursor-pointer text-xs font-medium ${selectedAgentTab === tab
                  ? "text-orange-600 border-b-2 border-orange-600"
                  : "text-gray-600"
                }`}
              onClick={() => setSelectedAgentTab(tab)}
            >
              <div className="text-lg font-bold">{getAgentTabCount(tab)}</div>
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </div>
          ))}
        </div>

        {/* Agent list */}
        <div className="p-3 space-y-2 h-full overflow-y-auto max-h-[calc(100vh-180px)]">
          {filteredAgents.map((agent) => (
            <div
              key={agent.id}
              className="flex flex-col bg-white p-3 pl-4 shadow-sm rounded-md border-l-4 cursor-pointer hover:bg-gray-50"
              style={{
                borderLeftColor:
                  agent.dutyStatus === "active" ? "#22C55E" : "#94A3B8",
              }}
            >
              {/* Name and status row */}
              <div className="flex justify-between items-center">
                <div className="font-semibold text-sm text-gray-900">
                  {agent.fullName}
                </div>

                <div className="flex items-center gap-2">
                  {/* Duty status badge */}
                  {/* Notification icon button */}
                  <button
                    className="text-orange-600 hover:text-orange-800"
                    onClick={() => {
                      setNotificationAgent(agent);
                      setNotificationModalOpen(true);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 17h5l-1.405-1.405C19.79 14.79 20 13.918 20 13V9a7.002 7.002 0 00-5-6.708V2a1 1 0 00-2 0v.292A7.002 7.002 0 006 9v4c0 .918.21 1.79.595 2.595L5 17h5m5 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                  </button>
                  <span
                    className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full
        ${agent.dutyStatus === "active"
                        ? "bg-green-100 text-green-700"
                        : agent.dutyStatus === "offline"
                          ? "bg-blue-100 text-blue-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                  >
                    <span className="w-2 h-2 rounded-full bg-current" />
                    {agent.dutyStatus.charAt(0).toUpperCase() +
                      agent.dutyStatus.slice(1)}
                  </span>
                </div>
              </div>

              {/* Divider */}
              <hr className="my-2 border-gray-200" />

              {/* Team name */}
              {agent.teamName && (
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 7h18M3 12h18M3 17h18"
                    />
                  </svg>
                  {agent.teamName}
                </div>
              )}
            </div>
          ))}

          {filteredAgents.length === 0 && (
            <div className="text-xs text-gray-400 text-center py-4">
              No agents found.
            </div>
          )}
        </div>
      </div>
      {/* modals here  */}
      {showDetailsModal && selectedTask && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-5xl w-full p-4 relative text-sm max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4 pb-3 border-b sticky top-0 bg-white z-10">
              <h2 className="text-lg font-semibold">Delivery Task Details</h2>
              <div className="flex items-center gap-2 sticky top-0">
                <select
                  className="p-2 border rounded text-xs"
                  value={localNewStatus}
                  onChange={(e) => setLocalNewStatus(e.target.value)}
                >
                  {statusOptions.map((status) => (
                    <option key={status} value={status}>
                      {status.toUpperCase()}
                    </option>
                  ))}
                </select>

                <button
                  className="bg-blue-600 text-white px-3 py-1.5 rounded text-xs shadow hover:bg-blue-700"
                  onClick={() =>
                    handleChangeStatus(localNewStatus, selectedTask)
                  }
                >
                  Change Status
                </button>

                <button
                  title="Close Task Details"
                  className="flex items-center justify-center text-gray-800 w-8 h-8 rounded-full shadow hover:bg-gray-400"
                  onClick={() => {
                    setShowDetailsModal(false);
                    setIsModalLoading(false);
                  }}
                >
                  <X size={16} />
                </button>
              </div>
            </div>

            {isModalLoading ? (
              <ModalContentShimmer />
            ) : (
              <>
                <div className="flex flex-col lg:flex-row gap-4">
                  {(selectedTask?.dropoff_latitude ||
                    selectedTask?.pickup_latitude) &&
                    (selectedTask?.dropoff_longitude ||
                      selectedTask?.pickup_longitude) && (
                      <div className="w-full lg:w-1/2 h-64 rounded overflow-hidden border">
                        <MapContainer
                          center={[
                            selectedTask?.dropoff_latitude ||
                            selectedTask?.pickup_latitude,
                            selectedTask?.dropoff_longitude ||
                            selectedTask?.pickup_longitude,
                          ]}
                          zoom={14}
                          scrollWheelZoom={false}
                          style={{ height: "100%", width: "100%" }}
                        >
                          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                          {selectedTask?.pickup_latitude &&
                            selectedTask?.pickup_longitude && (
                              <Marker
                                position={[
                                  selectedTask.pickup_latitude,
                                  selectedTask.pickup_longitude,
                                ]}
                                icon={iconRed}
                              >
                                <Popup>Pickup Location</Popup>
                              </Marker>
                            )}
                          {selectedTask?.dropoff_latitude &&
                            selectedTask?.dropoff_longitude && (
                              <Marker
                                position={[
                                  selectedTask.dropoff_latitude,
                                  selectedTask.dropoff_longitude,
                                ]}
                                icon={iconYellow}
                              >
                                <Popup>Delivery Location</Popup>
                              </Marker>
                            )}
                          {selectedTask?.driver_latitude &&
                            selectedTask?.driver_longitude && (
                              <Marker
                                position={[
                                  selectedTask.driver_latitude,
                                  selectedTask.driver_longitude,
                                ]}
                                icon={iconDriverActive}
                              >
                                <Popup>Driver Location</Popup>
                              </Marker>
                            )}
                        </MapContainer>
                      </div>
                    )}

                  <div className="w-full lg:w-1/2 overflow-x-auto">
                    <table className="w-full text-xs border">
                      <tbody>
                        <tr className="border-b">
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            Customer
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.customer_name || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b">
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            Contact
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.contact_number || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b">
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            Email
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.email_address || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b">
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            Driver
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.driver_name || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b">
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            Driver Mobile
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.driver_mobile || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b">
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            Distance
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.taskDistance || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-semibold px-2 py-1 bg-gray-100">
                            ETA
                          </td>
                          <td className="px-2 py-1">
                            {selectedTask?.taskEstimatedTime || "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="mt-4 text-xs">
                  <div className="mb-2">
                    <span className="font-semibold">Pickup Address:</span>{" "}
                    {selectedTask?.pickup_address || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold">Delivery Address:</span>{" "}
                    {selectedTask?.delivery_address || "N/A"}
                  </div>
                </div>

                <div className="mt-4">
                  {/* Accordion Header */}
                  <div
                    onClick={handleLogsToggle}
                    className="px-4 py-2 flex justify-between items-center cursor-pointer bg-gray-100 hover:bg-gray-200 transition-colors"
                  >
                    <h3 className="text-sm font-semibold">
                      Status & Assignment Logs
                    </h3>
                    <span
                      className={`transition-transform duration-300 text-gray-600 ${showLogs ? "rotate-180" : ""
                        }`}
                      style={{ fontSize: "16px" }}
                    >
                      ▼
                    </span>
                  </div>

                  {/* Accordion Content */}
                  <div
                    ref={contentRef}
                    style={{
                      height: `${contentHeight}px`,
                      transition: "height 300ms ease",
                      overflow: "hidden",
                    }}
                  >
                    <div className="p-3 border-t space-y-6 text-sm">
                      {/* Status Change Logs */}
                      {statusChangeLogs.length > 0 && (
                        <div className="border rounded p-3">
                          <h3 className="text-xs font-semibold mb-3 text-gray-700">
                            Status Change Logs
                          </h3>
                          <div className="w-full overflow-x-auto px-4 pb-6">
                            <div className="flex items-start justify-center relative">
                              {statusChangeLogs.map((log, idx) => {
                                const statusColorMap = {
                                  unassigned: "bg-gray-400",
                                  assigned: "bg-yellow-500",
                                  "food is ready": "bg-purple-500",
                                  "picked up": "bg-orange-500",
                                  inprogress: "bg-indigo-500",
                                  successful: "bg-green-500",
                                  failed: "bg-red-500",
                                  declined: "bg-pink-500",
                                  cancelled: "bg-gray-500",
                                  started: "bg-blue-500",
                                  acknowledged: "bg-teal-500",
                                  arrived: "bg-lime-500",
                                };

                                const statusColor =
                                  statusColorMap[log.status?.toLowerCase()] ||
                                  "bg-blue-500";

                                return (
                                  <div
                                    key={idx}
                                    className="flex flex-col items-center relative z-10 mx-6"
                                  >
                                    <div
                                      className={`w-8 h-8 flex items-center justify-center rounded-full text-white text-xs font-bold ${statusColor}`}
                                    >
                                      {idx + 1}
                                    </div>
                                    <div className="text-[10px] mt-1 text-center font-medium">
                                      {log.status?.toUpperCase() || "N/A"}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Assignment Logs */}
                      {assignmentLogs.length > 0 && (
                        <div className="border rounded p-3">
                          <h3 className="text-xs font-semibold mb-2 text-gray-700">
                            Assignment Logs
                          </h3>
                          <div className="overflow-x-auto">
                            <table className="table-auto w-full text-xs border">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="p-2 border">Assign Type</th>
                                  <th className="p-2 border">Driver ID</th>
                                  <th className="p-2 border">Driver Name</th>
                                  <th className="p-2 border">Task Status</th>
                                  <th className="p-2 border">Status</th>
                                  <th className="p-2 border">
                                    Assignment Date
                                  </th>
                                  <th className="p-2 border">Process Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {assignmentLogs.map((log, idx) => (
                                  <tr key={idx}>
                                    <td className="p-2 border">
                                      {log.assignType || "N/A"}
                                    </td>
                                    <td className="p-2 border">
                                      {log.driverId || "N/A"}
                                    </td>
                                    <td className="p-2 border">
                                      {log.driverName?.trim() || "N/A"}
                                    </td>
                                    <td className="p-2 border">
                                      {log.taskStatus || "N/A"}
                                    </td>
                                    <td className="p-2 border">
                                      {log.status || "N/A"}
                                    </td>
                                    <td className="p-2 border">
                                      {log.assignmentDate || "N/A"}
                                    </td>
                                    <td className="p-2 border">
                                      {log.processDate || "N/A"}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      {statusChangeLogs.length === 0 &&
                        assignmentLogs.length === 0 && (
                          <div className="text-gray-500 text-center py-4">
                            No logs available
                          </div>
                        )}
                    </div>
                  </div>
                </div>

                {selectedTask?.delivery_details?.items?.length > 0 ? (
                  <>
                    <h3 className="text-sm font-semibold mt-1 mb-2">
                      Delivery Items
                    </h3>
                    <div className="overflow-x-auto">
                      <table className="min-w-[700px] w-full text-xs border">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="px-2 py-2 text-left">Item</th>
                            <th className="px-2 py-2 text-left">Type</th>
                            <th className="px-2 py-2 text-left">Description</th>
                            <th className="px-2 py-2 text-left">W×H×L</th>
                            <th className="px-2 py-2 text-left">Weight</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedTask.delivery_details.items.map(
                            (item, index) => (
                              <tr key={index} className="border-t">
                                <td className="px-2 py-2">
                                  {item?.itemName || "N/A"}
                                </td>
                                <td className="px-2 py-2">
                                  {item?.itemType || "N/A"}
                                </td>
                                <td className="px-2 py-2">
                                  {item?.itemDescription || "N/A"}
                                </td>
                                <td className="px-2 py-2">
                                  {item?.width || 0}×{item?.height || 0}×
                                  {item?.length || 0}
                                </td>
                                <td className="px-2 py-2">
                                  {item?.weight || "N/A"}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <p className="text-xs text-center text-gray-500 mt-4">
                    No delivery item details available
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {showAssignModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white p-6 rounded shadow-lg w-[90%] max-w-md">
            <h2 className="text-lg font-semibold mb-4">
              Assign Driver to{" "}
              <span className="text-orange-500">
                {taskToAssign?.order_id || taskToAssign?.title}
              </span>
            </h2>
            <CustomSelectDriver
              agents={agents || []}
              selectedAgentId={selectedAgentId}
              setSelectedAgentId={setSelectedAgentId}
            />
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowAssignModal(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleAssignTask}
                className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      )}
      <SendNotificationModal
        isOpen={notificationModalOpen}
        onClose={() => setNotificationModalOpen(false)}
        driver={notificationAgent}
        baseurl={baseurl}
        token={token}
        setIsUnauthorised={setIsUnauthorised}
      />
    </div>
  );
}
